import * as api from '../../services/pc-version'

export const FETCH_PCVERSIONS = 'FETCH_PCVERSIONS';
export const FETCH_PCVERSION = 'FETCH_PCVERSION';



export const fetchPcversion = (id) => {
    return {
        type: FETCH_PCVERSION,
        payload: {
            promise: api.findPcversion({id: id})
        }
    }
}


export const fetchPcversions = (params, pagination, sort, extra) => {
    return {
        type: FETCH_PCVERSIONS,
        payload: {
            promise: api.findPcversions(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/pcClient.js